/**
 * Formatter standard per le percentuali
 */
export const PercentageFormatter = new Intl.NumberFormat('it-IT', {
  style: 'percent',
  maximumFractionDigits: 2,
});
